import { __rest } from 'tslib';
import React from 'react';
import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import { StyledVideoControlIconButtonContainer } from './VideoControlIconButton.styles.mjs';

const VideoControlIconButton = (_a) => {
    var { variant, children } = _a, iconButtonProps = __rest(_a, ["variant", "children"]);
    return (React.createElement(StyledVideoControlIconButtonContainer, { variant: variant, alignItems: "center", justifyContent: "center", gap: "0.5rem" },
        children,
        React.createElement(IconButtonComponent, Object.assign({}, iconButtonProps))));
};

export { VideoControlIconButton as default };
//# sourceMappingURL=VideoControlIconButton.mjs.map
